import {ErrorStateScheduleEnum} from '../../error-state-schedule.enum';

export enum CompanyVatDetailsFormErrorStatesEnum {
    VatDetailsUpdateFailed = ErrorStateScheduleEnum.CompanyVatDetailsFormFormStatesStartIndex
}
